import { faChartLine, faPowerOff, faWrench } from "@fortawesome/free-solid-svg-icons";
import { commonMenuItems } from "./common";
import defaultProfile, { asyncRoute, getOrderedConfDefSections } from "./default";
import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";
import { i18n } from "../i18n";

const { t } = i18n.global;
const isOfficial = (ctx: ProfileCtx) => ctx?.service?.config?.type == "rust_console_official";
// Remove files tab
const createMenu = (ctx: ProfileCtx): Menu => {
  const settingsMenuSection = {
    name: "settings",
    items: [
      new MenuItem(
        "",
        faChartLine,
        asyncRoute(() => import("../components/views/config/rust_console/RustConsoleStatus.vue")),
      ),
      new MenuItem(
        "settings",
        faWrench,
        asyncRoute(() => import("../components/views/config/rust_console/RustConsoleConf.vue")),
      ),
      commonMenuItems.logs,
      commonMenuItems.console,
    ],
  };
  // Only add file manager on official
  if (isOfficial(ctx)) {
    settingsMenuSection.items.push(commonMenuItems.fileManager);
  }
  // Replace the restarts page with our special version
  const administrationMenuSection = {
    name: "administration",
    items: [
      new MenuItem(
        "restarts",
        faPowerOff,
        asyncRoute(() => import("../components/views/config/rust_console/RustConsoleRestarts.vue")),
      ),
      ...defaultProfile(ctx).menu[1].items.slice(1),
    ],
  };
  return [settingsMenuSection, administrationMenuSection, ...defaultProfile(ctx).menu.slice(2)];
};

// Automatically build frontend config sections, overriding the RustConsolePreset component for now
function buildConfigSections(ctx: ProfileCtx): ConfigSection[] {
  const orderedConfDefSections = getOrderedConfDefSections(ctx);
  const sections = [];
  for (const [name, _] of orderedConfDefSections) {
    if (name === "preset") {
      sections.push({ component: "RustConsolePreset" });
    } else {
      sections.push({ component: "ConfSection", props: { name } });
    }
  }
  return sections;
}

const join = () => {
  window.open(t("ngp/settings/section/rust_ce_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(ctx),
  configSections: buildConfigSections(ctx),
  join: {
    buttonTextKey: "ngp/settings/section/rust_ce_wiki",
    joinFn: join,
  },
  statusPageConfig: {
    ...defaultProfile(ctx).statusPageConfig,
    showFtp: isOfficial(ctx), // only show ftp info on official
  },
});
